import { useLingui } from '@lingui/react/macro';
import { useMemo } from 'react';

import { type To } from '#features/routing';
import {
  CommentIcon,
  DiscoverIcon,
  EnterIcon,
  HomeIcon,
  MegaphoneIcon,
  UsersIcon,
} from '#features/ui';

type NavigationItem = {
  name: string;
  to: To;
  icon: React.ElementType;
  isProtected?: boolean;
  exact?: boolean;
};

export const useNavigationItems = () => {
  const { t } = useLingui();

  return useMemo(
    () =>
      [
        {
          name: t`common:auth.signIn`,
          to: '/{-$locale}/sign-in',
          icon: EnterIcon,
          isProtected: false,
          exact: true,
        },
        {
          name: t`dashboard:feed.title`,
          to: '/{-$locale}/dashboard',
          icon: HomeIcon,
          isProtected: true,
          exact: true,
        },
        {
          name: t`Discover`,
          to: '/{-$locale}/dashboard/discover',
          icon: DiscoverIcon,
          isProtected: true,
          exact: false,
        },
        {
          name: t`Chats`,
          to: '/{-$locale}/dashboard/chats',
          icon: CommentIcon,
          isProtected: true,
          exact: false,
        },
        {
          name: t`dashboard:feedback.title`,
          to: '/{-$locale}/feedback',
          icon: MegaphoneIcon,
          exact: true,
        },
        /*
          Друзья стоят там, где были настройки: из меню аватара раздел почти не находили
          (53 человека с телефона за 28 дней к 02.10), а настройки открывают в восемь раз реже
          чатов, и им хватает меню аватара.
        */
        {
          name: t({ id: 'friends:title', message: 'Friends' }),
          to: '/{-$locale}/dashboard/friends',
          icon: UsersIcon,
          isProtected: true,
          exact: false,
        },
      ] satisfies NavigationItem[],
    [t]
  );
};
